import { Auth } from 'aws-amplify';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PATHS } from 'src/constants';
import { useAlert } from '@common/hooks';
import { setIsAuthorizeAction, useAppDispatch } from 'src/store';

import styles from './styles.module.scss';
import { removetOnboardingStatus } from 'src/helpers/localStorageHelper';
import { Button } from '@common/components';
import classNames from 'classnames';

interface Props {
  className?: string;

}


const LogoutButton: FC <Props>= ({  className }) => {
  const dispatch = useAppDispatch();
  const { showAlert } = useAlert();

  const [t] = useTranslation('nav');
  const [c] = useTranslation('common');
  const basename = '/insight';

  const onLogoutHandler = async (): Promise<void> => {
    try {
      localStorage.setItem('eulaAccepted','');
      await Auth.signOut();
      dispatch(setIsAuthorizeAction(false));
      removetOnboardingStatus();
      // localStorage.removeItem('currentUserOrganizationInfo');
      window.location.href = `${basename}${PATHS.LOGIN}`;
    } catch (error) {
      if (error instanceof Error) {
        showAlert({
          id: error.message,
          title: c('Error'),
          message: error.message,
          variant: 'error',
        });
      }
    }
  };

  return (
    <Button data-menu-item className={classNames(styles.logoutBtn, className, {})} onClick={onLogoutHandler}>
      {t('logOutButton')}
    </Button>
  );
};

export default LogoutButton;
